var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhotoSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_1114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5C10.5 8.33333 10.2083 9.04167 9.625 9.625C9.04167 10.2083 8.33333 10.5 7.5 10.5C6.66667 10.5 5.95833 10.2083 5.375 9.625C4.79167 9.04167 4.5 8.33333 4.5 7.5C4.5 6.66667 4.79167 5.95833 5.375 5.375C5.95833 4.79167 6.66667 4.5 7.5 4.5C8.33333 4.5 9.04167 4.79167 9.625 5.375C10.2083 5.95833 10.5 6.66667 10.5 7.5ZM26.5 13.5V20.5H4.5V17.5L9.5 12.5L12 15L20 7L26.5 13.5ZM28 2.5H3C2.86458 2.5 2.7474 2.54948 2.64844 2.64844C2.54948 2.7474 2.5 2.86458 2.5 3V22C2.5 22.1354 2.54948 22.2526 2.64844 22.3516C2.7474 22.4505 2.86458 22.5 3 22.5H28C28.1354 22.5 28.2526 22.4505 28.3516 22.3516C28.4505 22.2526 28.5 22.1354 28.5 22V3C28.5 2.86458 28.4505 2.7474 28.3516 2.64844C28.2526 2.54948 28.1354 2.5 28 2.5ZM30.5 3V22C30.5 22.6875 30.2552 23.276 29.7656 23.7656C29.276 24.2552 28.6875 24.5 28 24.5H3C2.3125 24.5 1.72396 24.2552 1.23438 23.7656C0.744792 23.276 0.5 22.6875 0.5 22V3C0.5 2.3125 0.744792 1.72396 1.23438 1.23438C1.72396 0.744792 2.3125 0.5 3 0.5H28C28.6875 0.5 29.276 0.744792 29.7656 1.23438C30.2552 1.72396 30.5 2.3125 30.5 3Z",
    fill: "var(--text-hint)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotoSelect);
export default __webpack_public_path__ + "static/media/iconPhotoSelect.24449fa715f601f947d506fee8d68933.svg";
export { ForwardRef as ReactComponent };